import {defineStore} from 'pinia';
const acceptedCookiesStorage = localStorage.getItem("cookie-consent");

export const useCookiesStore = defineStore('cookies', {
	state: () => ({
		acceptCookies: acceptedCookiesStorage ? acceptedCookiesStorage === 'accept' : null,
	}),
	actions: {
		toggleCookiesChoice() {
			this.acceptCookies = true;
			localStorage.setItem("cookie-consent", "accept");

			if (typeof window.gtag !== 'undefined') {
				window.gtag('consent', 'update', {
					'ad_storage': this.acceptCookies ? 'granted' : 'denied',
					'ad_user_data': this.acceptCookies ? 'granted' : 'denied',
					'ad_personalization': this.acceptCookies ? 'granted' : 'denied',
					'analytics_storage': this.acceptCookies ? 'granted' : 'denied'
				});
			}
		},
		loadSavedData(savedData) {
			this.acceptCookies = savedData && savedData.hasOwnProperty("cookies") && savedData.cookies !== null ? savedData.cookies : null;
		},
		initConsent() {
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			window.gtag = gtag;

			gtag('consent', 'default', {
				'ad_storage': 'granted',
				'ad_user_data': 'granted',
				'ad_personalization': 'denied',
				'analytics_storage': 'granted'
			});

			if (this.acceptCookies === true) {
				gtag('consent', 'update', {
					'ad_storage': 'granted',
					'ad_user_data': 'granted',
					'ad_personalization': 'granted',
					'analytics_storage': 'granted'
				});
			}
		}
	}
});